import { Center, Flex } from '@chakra-ui/react';
import { formatTime } from '@/utils/interview-day-format';
import { KText } from '@/ui-library/components/text';

interface Chapter {
  gist: string;
  headline: string;
  start: number;
}

interface ChapterData {
  auto_chapters?: Chapter[];
}

interface ChapterProps {
  data: ChapterData;
  handleTimeJump: (time: number) => void;
}

export const Chapters = ({ data, handleTimeJump }: ChapterProps) => {
  const { auto_chapters: chapters } = data || {};
  return (
    <Flex mt="20px" flexDirection="column" width="100%">
      {chapters?.length > 0 ? (
        chapters.map((chapter) => (
          <Flex
            key={chapter?.start}
            alignItems="flex-start"
            cursor="pointer"
            width="100%"
            justifyContent="space-between"
            onClick={() => handleTimeJump(chapter?.start)}
            padding="20px 10px"
            borderRadius="8px"
            border="1px solid transparent"
            _hover={{
              border: '1px solid #E9E6EB',
              boxShadow: '0px 4px 8px #d6d6d663',
            }}
          >
            <Flex flexDir="column" gap="8px">
              <KText
                size="sm-semi-bold"
                fontWeight="semiBold"
                color="secondary-900"
              >
                {chapter?.gist}
              </KText>
              <KText size="sm-regular">{chapter?.headline}</KText>
            </Flex>
            <KText
              bg="#E3E4FE"
              color="#454CE7"
              p="2px 8px"
              borderRadius="xs"
              size="sm-medium"
              ml="45px"
            >
              {formatTime(chapter?.start)}
            </KText>
          </Flex>
        ))
      ) : (
        <Flex
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
        >
          <Center>
            <KText size="sm-regular" color="secondary-500">
              Chapters are not available for non-English languages
            </KText>
          </Center>
        </Flex>
      )}
    </Flex>
  );
};
